export default "__VITE_ASSET__CUXJSTH5__"